 

export default {
  GENERAL: [
    { text: 'Food Order', key: 'Food-Order', value: 'Food-Order' },
    { text: 'Food Recall', key: 'Food-Recall', value: 'Food-Recall' },
    { text: 'Telephone encounter note', key: '34748-4', value: '34748-4' },
    { text: 'Counseling note', key: '47042-7', value: '47042-7' },
    { text: 'Plan of care note', key: '56447-6', value: '56447-6' },
    { text: 'Referral note', key: '57133-1', value: '57133-1' },
    {
      text: 'Nutrition and dietetics Consult note',
      key: '34800-3',
      value: '34800-3',
    },
    { text: 'Nutrition and dietetics Note', key: '34801-1', value: '34801-1' },
    { text: 'Education note', key: '34895-3', value: '34895-3' },
    { text: 'Hospital Note', key: '34112-3', value: '34112-3' },
    { text: "Patient's home Progress note", key: '60592-3', value: '60592-3' },
    { text: 'Risk factors Document', key: '51898-5', value: '51898-5' },
    { text: 'Summary note', key: '68608-9', value: '68608-9' },
  ],
  FEEDBACK: [
    { text: 'Vendor-Issues', key: 'Vendor-Issues', value: 'Vendor-Issues' },
    {
      text: 'Member-Concerns',
      key: 'Member-Concerns',
      value: 'Member-Concerns',
    },
  ],
  ACTIONABLE_INSIGHTS: [
    { text: 'Emergency', key: 'Emergency', value: 'Emergency' },
    { text: 'Non-Emergency', key: 'Non-Emergency', value: 'Non-Emergency' },
    { text: 'Time-Sensitive', key: 'Time-Sensitive', value: 'Time-Sensitive' },
  ],
  ALL_FILTER: [
    { text: 'Food Order', key: 'Food-Order', value: 'Food-Order', alias: '' },
    {
      text: 'Food Recall',
      key: 'Food-Recall',
      value: 'Food-Recall',
      alias: '',
    },
    {
      text: 'Telephone encounter note',
      key: '34748-4',
      value: '34748-4',
      alias: '',
    },
    { text: 'Counseling note', key: '47042-7', value: '47042-7', alias: '' },
    { text: 'Referral note', key: '57133-1', value: '57133-1', alias: '' },
    {
      text: 'Nutrition and dietetics Consult note',
      key: '34800-3',
      value: '34800-3',
      alias: '',
    },
    {
      text: 'Nutrition and dietetics Note',
      key: '34801-1',
      value: '34801-1',
      alias: '',
    },
    { text: 'Education note', key: '34895-3', value: '34895-3', alias: '' },
    { text: 'Hospital Note', key: '34112-3', value: '34112-3', alias: '' },
    {
      text: "Patient's home Progress note",
      key: '60592-3',
      value: '60592-3',
      alias: '',
    },
    {
      text: 'Risk factors Document',
      key: '51898-5',
      value: '51898-5',
      alias: '',
    },
    { text: 'Summary note', key: '68608-9', value: '68608-9', alias: '' },
    {
      text: 'Communication',
      key: 'Communication',
      value: 'Communication',
      alias: '',
    },
    { text: 'Phone Call', key: 'Phone-Call', value: 'Phone-Call', alias: '' },

    {
      text: 'Positive Feedback',
      key: 'Positive-Feedback',
      value: 'Positive-Feedback',
      alias: '',
    },
    {
      text: 'Negative Feedback',
      key: 'Negative-Feedback',
      value: 'Negative-Feedback',
      alias: '',
    },
    {
      text: 'Health Plan Feedback',
      key: 'Health-Plan-Feedback',
      value: 'Health-Plan-Feedback',
      alias: '',
    },
    {
      text: 'Behavior Change',
      key: 'Behavior-Change',
      value: 'Behavior-Change',
      alias: '',
    },
    {
      text: 'Food Recall',
      key: 'Food-Recall',
      value: 'Food-Recall',
      alias: '',
    },
    {
      text: 'Triage (member concern)',
      key: 'Member-Concerns',
      value: 'Member-Concerns',
      alias: 'Member-Concerns',
    },
    {
      text: 'Triage (vendor issue)',
      key: 'Vendor-Issues',
      value: 'Vendor-Issues',
      alias: 'Vendor-Issues',
    },
    { text: 'Care Plan Note', key: '57133-1', value: '57133-1', alias: '' },
    {
      text: 'Member Information',
      key: 'Member-Information',
      value: 'Member-Information',
      alias: '',
    },
    {
      text: 'Health Information',
      key: 'Health-Information',
      value: 'Health-Information',
      alias: '',
    },
    {
      text: 'Nutrition and dietetics Note',
      key: '34801-1',
      value: '34801-1',
      alias: '',
    },
    {
      text: 'Education Distribution',
      key: '34895-3',
      value: '34895-3',
      alias: '',
    },
    {
      text: 'AI Non-Emergency',
      key: 'AI-Non-Emergency',
      value: 'AI-Non-Emergency',
      alias: 'Non-Emergency',
    },
    {
      text: 'AI Time-Sensitive',
      key: 'AI-Time-Sensitive',
      value: 'AI-Time-Sensitive',
      alias: 'Time-Sensitive',
    },
    {
      text: 'AI Emergency',
      key: 'AI-Emergency',
      value: 'AI-Emergency',
      alias: 'Emergency',
    },
  ],
  ALL: [
    { text: 'Communication', key: 'Communication', value: 'Communication' },
    { text: 'Phone Call', key: 'Phone-Call', value: 'Phone-Call' },
    {
      text: 'Positive Feedback',
      key: 'Positive-Feedback',
      value: 'Positive-Feedback',
    },
    {
      text: 'Negative Feedback',
      key: 'Negative-Feedback',
      value: 'Negative-Feedback',
    },
    {
      text: 'Health Plan Feedback',
      key: 'Health-Plan-Feedback',
      value: 'Health-Plan-Feedback',
    },
    {
      text: 'Behavior Change',
      key: 'Behavior-Change',
      value: 'Behavior-Change',
    },
    { text: 'Food Recall', key: 'Food-Recall', value: 'Food-Recall' },
    {
      text: 'Triage (member concern)',
      key: 'Member-Concerns',
      value: 'Member-Concerns',
    },
    {
      text: 'Triage (vendor issue)',
      key: 'Vendor-Issues',
      value: 'Vendor-Issues',
    },
    { text: 'Care Plan Note', key: '57133-1', value: '57133-1' },
    {
      text: 'Member Information',
      key: 'Member-Information',
      value: 'Member-Information',
    },
    {
      text: 'Health Information',
      key: 'Health-Information',
      value: 'Health-Information',
    },
    { text: 'Nutrition and dietetics Note', key: '34801-1', value: '34801-1' },
    { text: 'Education Distribution', key: '34895-3', value: '34895-3' },
    {
      text: 'AI Non-Emergency',
      key: 'AI-Non-Emergency',
      value: 'AI-Non-Emergency',
    },
    {
      text: 'AI Time-Sensitive',
      key: 'AI-Time-Sensitive',
      value: 'AI-Time-Sensitive',
    },
    { text: 'AI Emergency', key: 'AI-Emergency', value: 'AI-Emergency' },
    { text: 'Emergency', key: 'Emergency', value: 'Emergency' },
    { text: 'Resources', key: 'Resources', value: 'Resources' },
  ],
};
